import { ethers } from "ethers";
import { ACTIVE_CONTRACTS } from "../config/app.config";

import PurchaseAbi from "../abis/SmartcoreNodePurchase.json";
import ScnAbi from "../abis/SCNToken.json";
import Erc20Abi from "../abis/ERC20.json";

// signerOrProvider: a signer for writes, a provider for read-only.
export function getPurchaseContract(signerOrProvider) {
  return new ethers.Contract(ACTIVE_CONTRACTS.smartcorePurchase, PurchaseAbi, signerOrProvider);
}

export function getScnContract(signerOrProvider) {
  return new ethers.Contract(ACTIVE_CONTRACTS.scnToken, ScnAbi, signerOrProvider);
}

export function getUsdtContract(signerOrProvider) {
  return new ethers.Contract(ACTIVE_CONTRACTS.usdt, Erc20Abi, signerOrProvider);
}
